import OverdueAssessmentCard from '~/components/common/OverdueAssessmentsSection/OverdueAssessmentsCard';
import { AssessmentEvents } from '~/analytics';
import {
  AssessmentEventAttribute,
  AssessmentEventSource,
} from '~/analytics/assessmentEvents';
import { PatientTabs } from '~/lib/constants/patients.constants';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import {
  PortalComponent,
  useComponentPortalContext,
} from '~/lib/contexts/ComponentPortalContext';
import { useOverdueCoreAssessments } from '~/lib/hooks/useOverdueCoreAssessments';
import { PatientTabsCollection } from '~/lib/hooks/usePatientTabsCollection';

import { RailSection } from './RailSection';
import { RailSectionErrorLabel } from './rightRail.constants';

interface OverviewAssessmentsSectionProps {
  patientId: string;
}

const OverviewAssessmentsSection = ({
  patientId,
}: OverviewAssessmentsSectionProps) => {
  const { trackEvent } = useAnalytics();
  const { setComponentVisibility } = useComponentPortalContext();
  const { admitDate, isError, isLoading, overdueCoreAssessments } =
    useOverdueCoreAssessments(patientId);

  const handleClickCompleteTogether = (surveyResponse: SurveyResponse) => {
    trackEvent(
      AssessmentEvents.completeTogetherAssessmentCardOverdueButtonClicked,
      {
        [AssessmentEventAttribute.SurveyId]: surveyResponse.surveyExternalId,
        [AssessmentEventAttribute.SurveyName]: surveyResponse.surveyName,
        [AssessmentEventAttribute.Source]:
          AssessmentEventSource.PatientOverviewTab,
        [AssessmentEventAttribute.ResponseExternalId]:
          surveyResponse.responseExternalId,
        [AssessmentEventAttribute.UserId]: surveyResponse.userId,
      },
    );
    setComponentVisibility({
      component: PortalComponent.SURVEY_ACCORDION,
      data: surveyResponse,
      isExpanded: true,
      isVisible: true,
    });
  };

  const rows = overdueCoreAssessments.map((groupedAssessment) => (
    <OverdueAssessmentCard
      admitDate={admitDate}
      groupedAssessment={groupedAssessment}
      isFlat
      key={groupedAssessment.externalId}
      onClickCompleteTogether={handleClickCompleteTogether}
    />
  ));

  return (
    <RailSection
      action={{
        linkTo: PatientTabsCollection[PatientTabs.ASSESSMENTS].subPath,
        patientId,
        rightLinkText: 'View all',
      }}
      badge={{
        count: overdueCoreAssessments.length,
        counterId: 'overdue-assessments__counter',
        description: 'overdue',
        type: 'counter',
      }}
      // Overdue assessments are exempt from the rail's three-row cap.
      cap={Infinity}
      emptyCaption="No core assessments are currently overdue"
      errorLabel={RailSectionErrorLabel.Assessments}
      headerText="Assessments"
      id="patient-overview-right-rail-v2__assessments"
      isError={isError}
      isLoading={isLoading}
      rows={rows}
    />
  );
};

export default OverviewAssessmentsSection;
